import { render } from "./Switch.vue?vue&type=template&id=796d32ba&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=796d32ba&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796d32ba"]])

export default __exports__